class AnnouncementBanner extends HTMLElement {
  bindEvents() {
    this.$close.addEventListener('click', this.handleClick.bind(this));
  }

  bindUI() {
    this.$close = this.querySelector('[data-ref="$close"]');
  }

  connectedCallback() {
    this.setVars();
    this.bindUI();
    this.bindEvents();
    this.update();
  }

  handleClick() {
    this.isVisible = false;
    this.dismissedAnnouncements.push(this.announcementId);
    localStorage.setItem('dismissedAnnouncements', this.dismissedAnnouncements.join(','));

    this.update();
  }

  setVars() {
    this.announcementId = this.getAttribute('announcement-id');
    this.dismissedAnnouncements = localStorage.getItem('dismissedAnnouncements')?.split(',') || [];

    this.isVisible = !this.dismissedAnnouncements.includes(this.announcementId);
  }

  update() {
    this.setAttribute('is-visible', this.isVisible);
  }
}

if (!customElements.get('announcement-banner')) {
  customElements.define('announcement-banner', AnnouncementBanner);
}
